






















































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';

import DialogFooter from '@/components/UI/DialogFooter.vue';
import BtnDefault from '@/components/UI/BtnDefault.vue';
import SupportDialog from '@/components/beta/SupportDialog.vue'
import {validatorMail} from "@/helpers/validators";

const dialog = namespace('dialog')
const forms = namespace('forms')
const profile = namespace('profile')
const resources = namespace('resources')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
    SupportDialog,
  },
  name: "EditProfileForm"
})
export default class EditProfileForm extends Vue {
  @resources.Getter('getCountries') protected getCountries: any
  @resources.Action('getCountryFromServer') protected getCountryFromServer: any

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('setSupportDialog') protected setSupportDialog: any
  @dialog.Mutation('setSupportDialogOption') protected setSupportDialogOption: any
  @dialog.Mutation('setSupportDialogSubtitle') protected setSupportDialogSubtitle: any
  @dialog.Mutation('setSupportDialogTitle') protected setSupportDialogTitle: any


  @forms.Getter('options') protected options: any
  @profile.Getter('getUser') protected getUser: any
  @profile.Action('patchProfileUser') protected patchProfileUser: any

  firstName: string = ''
  lastName: string = ''
  description: string = ''
  email: string = ''
  phone: string = ''
  site: string = ''
  postcode: string = ''
  country: string = ''
  region: string = ''
  address: string = ''
  city: string = ''
  search: string = ''
  isError: any = {
    firstName: false,
    lastName: false,
    email: false
  }

  dialogSupport: boolean = false

  refreshUser() {
    this.firstName = this.getUser.firstName
    this.lastName = this.getUser.lastName
    this.description = this.getUser.description

    this.email = this.getUser.contacts.filter((el: any) => el.type == 'email').length ? this.getUser.contacts.filter((el: any) => el.type == 'email')[0].value : ''
    this.phone = this.getUser.contacts.filter((el: any) => el.type == 'phone').length ? this.getUser.contacts.filter((el: any) => el.type == 'phone')[0].value : ''
    this.site = this.getUser.contacts.filter((el: any) => el.type == 'site').length ? this.getUser.contacts.filter((el: any) => el.type == 'site')[0].value : ''

    this.country = this.getUser.location ? this.getUser.location._country : ''
    this.postcode = this.getUser.location ? this.getUser.location.postcode : ''
    this.region = this.getUser.location ? this.getUser.location.region : ''
    this.city = this.getUser.location ? this.getUser.location.city : ''
    this.address = this.getUser.location ? this.getUser.location.address : ''
  }

  async mounted() {
    await this.getCountryFromServer()
    this.refreshUser()
  }

  //
  closeDialog() {
    this.SetFullDialogShow(false)
  }

  openSupport() {
    this.setSupportDialogOption('change_user_login')
    this.setSupportDialog(true)
  }

  validEmail() {
    // let re = /^[\w-\.]+@[\w-]+\.[a-z]{2,4}$/i;
    // return re.test(this.email)
    return validatorMail(this.email)
  }

  save(item: string) {
    let flag = false
    let value = null
    let flag2 = null
    let contacts = this.getUser.contacts || []

    this.isError.firstName = this.firstName == ''
    this.isError.lastName = this.lastName == ''
    this.isError.email = this.email != '' && !this.validEmail()

    for (let key in this.isError) {
      if (this.isError[key]) flag = true
    }

    if (!flag) {

      switch (item) {
        case 'postcode':
        case 'region':
        case 'address':
        case 'city':
        case 'country':

          let payload = {
            postcode: this.postcode,
            region: this.region,
            address: this.address,
            city: this.city,
            _country: this.country,
          }
          value = {
            "location": payload
          }
          flag2 = true

          break;
        case 'firstName':
          if (this.getUser.firstName !== this.firstName) {
            value = {
              "firstName": this.firstName
            }
            flag2 = true
          }
          break;
        case 'lastName':
          if (this.getUser.lastName !== this.lastName) {
            value = {
              "lastName": this.lastName
            }
            flag2 = true
          }
          break;
        case 'description':
          if (this.getUser.description !== this.description) {
            value = {
              "description": this.description
            }
            flag2 = true
          }
          break;
        case 'phone':
          if (this.getUser.contacts.filter((el: any) => el.type == 'phone').length) {
            if (this.phone === '') {
              let help = this.getUser.contacts.filter((el: any) => {
                if (el.type !== 'phone') {
                  return el
                }
              })
              value = {
                "contacts": help
              }
              flag2 = true
            } else {
              this.getUser.contacts.filter((el: any) => el.type == 'phone')[0].value = this.phone
              value = {
                "contacts": this.getUser.contacts
              }
              flag2 = true
            }
          }

          if (!this.getUser.contacts.filter((el: any) => el.type == 'phone').length) {
            if (this.phone == '') {
              return;
            } else {
              contacts.push({
                value: this.phone,
                type: 'phone',
                title: ''
              })
              value = {
                "contacts": contacts
              }
              flag2 = true
            }
          }
          break;
        case 'email':
          if (this.getUser.contacts.filter((el: any) => el.type == 'email').length) {
            if (this.email === '') {
              let help = this.getUser.contacts.filter((el: any) => {
                if (el.type !== 'email') {
                  return el
                }
              })
              value = {
                "contacts": help
              }
              flag2 = true
            } else {
              this.getUser.contacts.filter((el: any) => el.type == 'email')[0].value = this.email
              value = {
                "contacts": this.getUser.contacts
              }
              flag2 = true
            }
          }

          if (!this.getUser.contacts.filter((el: any) => el.type == 'email').length) {
            if (this.email == '') {
              return;
            } else {
              contacts.push({
                value: this.email,
                type: 'email',
                title: ''
              })
              value = {
                "contacts": contacts
              }
              flag2 = true
            }
          }
          break;
        case 'site':
          if (this.getUser.contacts.filter((el: any) => el.type == 'site').length) {
            if (this.site === '') {
              let help = this.getUser.contacts.filter((el: any) => {
                if (el.type !== 'site') {
                  return el
                }
              })
              value = {
                "contacts": help
              }
              flag2 = true
            } else {
              this.getUser.contacts.filter((el: any) => el.type == 'site')[0].value = this.site
              value = {
                "contacts": this.getUser.contacts
              }
              flag2 = true
            }
          }

          if (!this.getUser.contacts.filter((el: any) => el.type == 'site').length) {
            if (!this.site) {
              return;
            } else {
              contacts.push({
                value: this.site,
                type: 'site',
                title: ''
              })
              value = {
                "contacts": contacts
              }
              flag2 = true
            }
          }
          break;

      }

      if (flag2) {
        this.patchProfileUser({
          body: value
        })
      }
      flag2 = false
    }

  }


}
